import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 18a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M5 6a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M15 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-2"}],["path",{"d":"M7 8l0 8","key":"svg-3"}],["path",{"d":"M7 8a4 4 0 0 0 4 4h4","key":"svg-4"}]]

const IconGitMerge = createReactComponent('outline', 'git-merge', 'GitMerge', __iconNode);

export default IconGitMerge;